export function setWindowGA(dtm: object) {
	if (typeof window !== 'undefined') {
		if (window.dataLayer) {
			let newDtm = {}
			newDtm = { ...dtm }
			window.dataLayer.push(newDtm)
		}
	}
}
